export default __webpack_public_path__ + "static/media/pic2.b81e15cd.jpg";